<template>
  <div class="container">
    <div class="index" v-if="!detail.show">
      <div class="title">
        <span>黑名单人员管理</span>
      </div>
      <div class="query">
        <el-form ref="form" :model="form" label-width="90px"> </el-form>
        <div class="query">
          <el-form ref="form" :inline="true" :model="form" label-width="90px">
            <el-form-item label="">
              <el-input
                v-model="form.courseName"
                clearable
                placeholder="请输入教师姓名"
              />
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" size="small" @click="searchFun"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
        >
          <el-table-column
            align="center"
            prop="q"
            label="教师姓名"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="w"
            label="账号"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="e"
            label="国籍"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column
            align="center"
            prop="r"
            label="证件类型"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="t"
            label="来源"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="y"
            label="时间"
            show-overflow-tooltip
          >
          </el-table-column>
             <el-table-column
            align="center"
            prop="u"
            label="职业证书"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>
    <!-- <Detail :info="detail.info" v-if="detail.show" @to-index="toIndex"></Detail> -->
  </div>
</template>

<script>
import dayjs from "dayjs";
import api from "@/api/wisdomSchool/index";
// import store from '@/store';
export default {
  //   components: {
  //     Detail: () => import("./details.vue"),
  //   },
  data() {
    return {
      form: {
        schoolYearSemester: "",
        extOrgName: "",
        courseName: "",
        startDate: "",
        endDate: "",
        selectData: "",
      },
      semesterList: [],
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 10,
      },

      info: "", // 出库单页面参数
      tableData: [
        // {q:'郭琼莲',w: "jm****4693",e: "中国",r: "教师资格证",t: "教育部同步",y: "2021/1/19 22:05:04",u: "教师资格证",},  
        // {q:'幸云卿',w: "jm****4698",e: "中国",r: "教师资格证",t: "省级同步",y: "2021/1/19 22:05:04",u: "教师资格证",},  
        // {q:'凤月加',w: "jm****4699",e: "中国",r: "教师资格证",t: "省级同步",y: "2021/1/19 22:05:04",u: "教师资格证",},  
        // {q:'向茜娣',w: "jm****4696",e: "中国",r: "教师资格证",t: "省级同步",y: "2021/1/19 22:05:04",u: "教师资格证",},  
      ],
      currentPage: 4,
      detail: {
        info: {},
        show: false,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {},
  created() {
    if (this.semesterArr.length > 0) {
      this.semesterList = this.semesterArr.map((v) => ({
        label: v.schoolYear + "年度" + (v.semester === 1 ? "上学期" : "下学期"),
        value: v.schoolYear + "_" + v.semester,
        id: v.id,
      }));
    }
    console.log("获取学年学期数据--", this.semesterList);
    // this.getDataList();
  },
  methods: {
    async getDataList() {
      if (this.form.selectData == "" || this.form.selectData == null) {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      let params = {
        schoolYearSemester: this.form.schoolYearSemester,
        startDate: this.form.startDate,
        endDate: this.form.endDate,
        teacherId: "", 
        courseName: this.form.courseName,
        extOrgName: this.form.extOrgName,
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        page: this.page.pageNum,
        limit: this.page.pageSize,
      };
      var { data, code } = await api.teacherCourseAttendance(params);
      console.log("获取考勤列表数据---", data);
      if (code == "0") {
        this.tableData = data.list;
        this.page.totalPage = data.total;
      }
    },
    searchFun() {
      this.page.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.page.pageSize = val;
      this.getDataList();
    },

    currentChangeHandle(val) {
      this.tableData = [];
      this.page.pageNum = val;
      this.getDataList();
    },
    toDetail(scope) {
      //   console.log(scope);
      //   this.detail.info = scope.row;
      //   this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner {
  width: 170px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 0 0 2% 2%;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}
</style>
